import { Component, h } from 'preact';
// import scrollWatcher from '../utils/scroll-watcher';

import Countdown from './countdown';
import OfficeChooser from './office-chooser';

class ControlBar extends Component {
  // constructor (props) {
  //   super(props);
  //
  //   this.stickyBar = this.stickyBar.bind(this);
  // }

  // componentDidMount () {
  //   scrollWatcher.add(this.stickyBar);
  // }
  //
  // componentWillUnmount () {
  //   scrollWatcher.remove(this.stickyBar);
  // }

  // stickyBar () {
  //   console.log(this.base.getBoundingClientRect());
  // }

  render () {
    const timeLeft = this.props.timeLeft;

    return (
      <div className="control-bar">
        <OfficeChooser onChange={this.props.onOfficeFilter} />
        <Countdown noLine={true} timeLeft={timeLeft} />
      </div>
    );
  }
}

export default ControlBar;



// WEBPACK FOOTER //
// ./components/control-bar.js